import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import fetchOrders from './fetchOrders';
import useOrdersFilters from '../filterBar/useOrdersFilters';
import ordersSlice from './ordersSlice';

const useFetchOrders = (autoload = true): (() => void) => {
  const dispatch = useDispatch();
  const { filters } = useOrdersFilters();
  const {
    page,
    limit,
    order,
    column,
    startDate,
    endDate,
    ordersState,
    searchText,
  } = filters;
  const { setPageNumber } = ordersSlice.actions;
  const loadOrders = useCallback(() => {
    dispatch(fetchOrders(filters));
  }, [dispatch, filters]);

  useEffect(() => {
    return (): void => {
      dispatch(setPageNumber(1));
    };
  }, [dispatch, setPageNumber]);

  useEffect(() => {
    (async (): Promise<void> => {
      if (autoload) {
        loadOrders();
      }
    })();
  }, [
    page,
    limit,
    order,
    column,
    startDate,
    endDate,
    searchText,
    ordersState,
    loadOrders,
    autoload,
  ]);

  return loadOrders;
};

export default useFetchOrders;
